import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {DomSanitizer, SafeHtml, SafeUrl} from '@angular/platform-browser';
import {ClientResponse, Localization, SdkOptions} from '@identy/identy-finger';

@Component({
  selector: 'app-transaction-dialog',
  templateUrl: './transaction-dialog.component.html',
  styleUrls: ['./transaction-dialog.component.css']
})
export class TransactionDialogComponent implements OnInit {

  public hand: SafeUrl;
  public closeButtonlabel = 'Close';
  public retryButtonLabel = 'Retry';
  public showRetry: boolean;
  public showIcon: string;
  public description: SafeHtml;
  public retryCodes: any;
  @Input() private data: ClientResponse;
  @Input() private options: SdkOptions;
  @Input() private localization: Localization;
  // tslint:disable-next-line:ban-types
  @Input() private onclose: Function;
  // tslint:disable-next-line:ban-types
  @Input() private onretry: Function;
  private height: number;

  constructor(private bsModalRef: BsModalRef, private sanitizer: DomSanitizer) {
    this.height = 0;
    this.retryCodes = [401, 402, 403, 500, 501, 604];
  }

  ngOnInit() {


    this.showRetry = this.retryCodes.indexOf(this.data.code) !== -1;
    this.showIcon = 'user';
    if (this.data.code.toString() === '200') {
      this.showIcon = 'success';
    } else if (this.data.code.toString() === '500') {
      this.showIcon = 'error';
    }

    if (!this.showRetry) {
      this.closeButtonlabel = 'Close';
    }
    let message = '';
    if (this.data.code === 600) {
      message = this.localization.getString('FEEDBACK_LICENCE_INVALID');
    } else {
      message = this.localization.getString(this.data.feedback_code.toString());
    }
    this.description = this.sanitizer.bypassSecurityTrustHtml(message);
  }

  onCloseClicked() {
    if (this.onclose) {
      this.onclose();
    }
  }

  onRetryClicked() {
    if (this.onretry) {
      this.onretry();
    }
    this.bsModalRef.hide();
  }
}


